import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import { Redirect } from "react-router";
import { Card } from "components/Card/Card.jsx";
import { connect } from "react-redux";
import { updateCustomer } from "../../redux/actions";
import { NotificationManager } from "react-notifications";
import Switch from "react-switch";

const mapStateToProps = (state) => {
  return {
    selectedCustomer: state.selectedCustomer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCustomer: (selected, customer) =>
      dispatch(updateCustomer(selected, customer)),
  };
};

class EditProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canVisitPage: false,
      customer: {
        firstName: "",
        lastName: "",
        code: "",
        call: "",
        phone: "",
        isBlocked: false,
      },
    };
    this.changeFirstName = this.changeFirstName.bind(this);
    this.changeLastName = this.changeLastName.bind(this);
    this.changeCall = this.changeCall.bind(this);
    this.changePhone = this.changePhone.bind(this);
    this.changeCode = this.changeCode.bind(this);
    this.updateCustomer = this.updateCustomer.bind(this);
    this.changeIsBlocked = this.changeIsBlocked.bind(this);
  }

  changeFirstName(e) {
    this.setState({
      customer: { ...this.state.customer, firstName: e.target.value },
    });
  }

  changeLastName(e) {
    this.setState({
      customer: { ...this.state.customer, lastName: e.target.value },
    });
  }

  changeCall(e) {
    this.setState({
      customer: { ...this.state.customer, call: e.target.value },
    });
  }

  changeIsBlocked(checked) {
    this.setState({
      customer: { ...this.state.customer, isBlocked: checked },
    });
  }

  changePhone(e) {
    this.setState({
      customer: { ...this.state.customer, phone: e.target.value },
    });
  }

  changeCode(e) {
    this.setState({
      customer: { ...this.state.customer, code: e.target.value },
    });
  }

  updateCustomer(e) {
    e.preventDefault();
    this.props.updateCustomer(this.props.selectedCustomer, this.state.customer);
    NotificationManager.success(
      "اطلاعات مشتری با موفقیت بروزرسانی شد",
      "انجام شد"
    );
  }

  componentWillMount() {
    this.setState({ customer: this.props.selectedCustomer });
    // console.log(this.props.selectedCustomer);
    if (
      this.props.selectedCustomer == undefined ||
      this.props.selectedCustomer == {}
    ) {
      this.setState({ canVisitPage: false });
    } else {
      this.setState({ canVisitPage: true });
    }
  }

  render() {
    if (!this.state.canVisitPage) {
      return <Redirect to={"/customers"} />;
    }
    return (
      <Row>
        <Col md={12}>
          <Card
            title="ویرایش اطلاعات"
            content={
              <form>
                <Row className="float-right">
                  <Col xs={6}>
                    <FormGroup>
                      <ControlLabel>نام</ControlLabel>
                      <FormControl
                        type="text"
                        bsClass="form-control"
                        placeholder="نام"
                        defaultValue={this.state.customer.firstName}
                        onChange={this.changeFirstName}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6}>
                    <FormGroup>
                      <ControlLabel>نام خانوادگی</ControlLabel>
                      <FormControl
                        type="text"
                        // value={this.state.customer.lastName}
                        bsClass="form-control"
                        placeholder="نام خانوادگی"
                        defaultValue={this.state.customer.lastName}
                        onChange={this.changeLastName}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <FormGroup>
                      <ControlLabel>تلفن ثابت</ControlLabel>
                      <FormControl
                        type="text"
                        defaultValue={this.state.customer.phone}
                        bsClass="form-control"
                        placeholder="تلفن ثابت"
                        onChange={this.changePhone}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6}>
                    <FormGroup>
                      <ControlLabel>شماره همراه</ControlLabel>
                      <FormControl
                        type="text"
                        defaultValue={this.state.customer.call}
                        bsClass="form-control"
                        placeholder="شماره همراه"
                        onChange={this.changeCall}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <FormGroup>
                      <ControlLabel>کد اشتراک</ControlLabel>
                      <FormControl
                        type="text"
                        defaultValue={this.state.customer.code}
                        bsClass="form-control"
                        placeholder="کد اشتراک"
                        onChange={this.changeCode}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6}>
                    <FormGroup>
                      <ControlLabel>بلاک کردن مشتری</ControlLabel>
                      <div>
                        <Switch
                          onChange={this.changeIsBlocked}
                          checked={this.state?.customer?.isBlocked}
                          onColor="#d93327"
                        />
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <Button
                  bsStyle="info"
                  onClick={this.updateCustomer}
                  pullRight
                  fill
                  type="submit"
                >
                  بروزرسانی
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    );
  }
}

const EditProfileConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProfile);

export default EditProfileConnect;
